import { render, staticRenderFns } from "./VamosPaLaCalleGaleria.vue?vue&type=template&id=1c0af40b&scoped=true"
import script from "./VamosPaLaCalleGaleria.vue?vue&type=script&setup=true&lang=js"
export * from "./VamosPaLaCalleGaleria.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0af40b",
  null
  
)

export default component.exports